<template>
    <div>
        <confetti></confetti>
        <div class="confirmation-wrapper">
            <div class="icon-wrapper">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="Layer 1"
                    viewBox="0 0 96 96"
                >
                    <path
                        pathLength="1"
                        class="circle"
                        fill="none"
                        stroke="#A3CDEA"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="7"
                        d="M92.21 48A44.21 44.21 0 1148 3.79"
                    />
                    <path
                        pathLength="1"
                        class="check"
                        fill="none"
                        stroke="#3498DB"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="7"
                        d="M25.58 41.04l19.58 19.58 45.66-45.66"
                    />
                </svg>
            </div>
            <div v-if="application_status.toLocaleLowerCase() === 'contact office'">
                <h2>Your application was submitted!</h2>
                <p>However, we were unable to electronically approve you. The leasing office will contact you soon.</p>
            </div>
            <div v-else>
                <h2>Your application was successfully submitted!</h2>
                <p>As soon as your application has been reviewed you will be contacted by a property staff.</p>
            </div>
        </div>
        <div class="w-full bg-white flex flex-col flex-1 flex fixed bottom-0 p-4 mx-4">
            <h2 class="font-bold text-start my-4 text-base">
                Application status:
                <span class="text-purple-600">{{ application_status }}</span>
            </h2>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'ScreeningConfirmation',
    data() {
        return {
            application_status: 'Application submitted',
        };
    },

    computed: {
        ...mapGetters({
            getApplication: 'application/getApplication',
        }),
    },

    beforeMount() {
        if (this.getApplication) {
            switch (this.getApplication.application_process_status) {
            case 'Accepted':
                this.application_status = 'Accepted';
                break;
            case 'Identity verification':
            case 'Background screening':
                this.application_status = 'Background screening';
                break;
            case 'Mitigation':
                this.application_status = 'Contact Office';
                break;
            case 'Declined':
                this.application_status = 'Declined';
                break;

            default:
                this.application_status = 'Background screening';
                break;
            }
        }
    },
};
</script>

<style scoped>
.confirmation-wrapper {
    text-align: center;
}

.confirmation-wrapper > h2 {
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
    margin-top: 1rem;
    line-height: 1.3;
}

.confirmation-wrapper > p {
    text-align: center;
    font-size: 1.125rem;
    line-height: 1.5;
    margin: 0 auto;
}
.icon-wrapper {
    width: 100%;
    margin: 0 auto;
    text-align: center;
}
.icon-wrapper svg {
    width: 10rem;
    margin: 0 auto;
    text-align: center;
}
.circle,
.check {
    stroke-dasharray: 1;
    stroke-dashoffset: 1;
}
.circle {
    animation: showCircle 0.6s cubic-bezier(0.92, 0.26, 0.53, 0.48) forwards;
}
.check {
    animation: showCircle 0.65s cubic-bezier(0.92, 0.26, 0, 1) forwards;
    animation-delay: 0.15s;
}
@keyframes showCircle {
    to {
        stroke-dashoffset: 0;
    }
}
</style>
